import React from 'react';
import UserContainer from './UserContainer';

export const MESSAGES = {
  title: 'Listado de usuarios',
  created: 'El usuario ha sido creado correctamente',
  edited: 'El usuario ha sido editado correctamente',
  deleted: 'El usuario ha sido eliminado correctamente',
  deleteConfirmation: user =>
    `¿Estas seguro de que queres eliminar al usuario ${user.firstName} ${user.lastName}?`,
};

const COLUMNS = [
  {
    id: 'firstName',
    label: 'Nombre',
    minWidth: 100,
    hidden: {
      xsDown: true,
    },
  },
  {
    id: 'lastName',
    label: 'Apellido',
    minWidth: 100,
    hidden: {
      xsDown: true,
    },
  },
  {
    id: 'email',
    label: 'Mail',
    minWidth: 150,
    hidden: { mdDown: true },
  },
];

export const ENTITY_PROPS = {
  entityName: 'usuario',
  endpoint: 'users',
  path: '/home/users',
};

const UserTable = () => {

  const handleServiceUserFilter = (row) => {
    if (row.isServiceUser) {
      return true
    }
    return false
  }

  const searchFilter = (row, word) => {
    const lowercaseWord = word.toLowerCase()
    const nameLastName = `${row.firstName?.toLowerCase()} ${row.lastName?.toLowerCase()}`
    const lastNameFirstName = `${row.lastName?.toLowerCase()} ${row.firstName?.toLowerCase()}`
    return nameLastName.toLowerCase().includes(lowercaseWord) ||
           lastNameFirstName.toLowerCase().includes(lowercaseWord) ||
           row.email?.toLowerCase().includes(lowercaseWord)
  }

  return <UserContainer enableEdit={false} searchEnabled={true} searchFilter={searchFilter} allowCreateNew={false} entityProps={ENTITY_PROPS} messages={MESSAGES} columns={COLUMNS} filterEnabled={true} filter={handleServiceUserFilter} />;
};

export default UserTable;
